import React from 'react';
import { PropTypes } from 'prop-types';
import './LoadJsonToForm.scss';
import { Form, Button, Input, Upload, Space, InputNumber } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Divider } from 'rc-menu';

import Text from 'antd/lib/typography/Text';
import { uploadImage } from '../../services/imageService';
import _ from 'lodash';

const LoadJsonToForm = ({ form, setInitialValues, formatJson = null }) => {
  return (
    <>
      <Upload
        accept=".json, .txt"
        showUploadList={false}
        beforeUpload={(file) => {
          const reader = new FileReader();

          reader.onload = (e) => {
            //ToDo reshape date
            let parsed = { ...JSON.parse(e.target.result) };
            if (formatJson) formatJson(parsed);
            form.setFieldsValue(parsed);
            if (setInitialValues) setInitialValues(parsed);
          };
          reader.readAsText(file);

          // Prevent upload
          return false;
        }}>
        <h1>
          <Button icon={<UploadOutlined />}>
            Click to Upload <strong> Json </strong>
          </Button>
        </h1>
      </Upload>
    </>
  );
};

export default LoadJsonToForm;
